import { useQuery } from '@tanstack/react-query'
import { useTRPC } from '~/services/trpc'
import { UserRecord, UserType } from '~/stores/stores.types'

import { HomepageView } from '@hap/constants'

const sanitizeUserType = (ut?: string) => {
  switch (ut) {
    case 'Agent':
      return UserType.Agent
    case 'Admin':
      return UserType.Admin
    case 'Proxy':
      return UserType.Proxy

    default:
      return UserType.Agent
  }
}

export const useCurrentUserQuery = () => {
  const trpc = useTRPC()
  return useQuery(
    trpc.users.getCurrentUser.queryOptions(undefined, {
      staleTime: 60 * 60 * 1000, // 1 hour
      refetchInterval: (query) => {
        const data = query.state.data
        return data?.impersonation ? 60 * 1000 : false
      },
      refetchIntervalInBackground: true,
    }),
  )
}

const useCurrentUser = (): Nullable<
  UserRecord & {
    permissions: Array<{ resource: string; action: string }>
    allowedFilterFields: string[] | null
    roleHomepageDefault: HomepageView
    impersonation: {
      sessionId: string
      impersonatorUserId: string
      impersonatedUserId: string
    } | null
  }
> => {
  const { data: user } = useCurrentUserQuery()
  return user
    ? {
        ...user,
        roleHomepageDefault: user.roleHomepageDefault as HomepageView,
        userType: sanitizeUserType(user.userType),
      }
    : null
}

export default useCurrentUser
